import {
  mapGetters,
  mapActions,
  mapMutations
} from 'vuex'

import * as commentsStore from '@/store/comments'

export {
  commentsStore
}

/**
   * Search store.
   *
   * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
   */
export const createCommentsStoreMixin = (without = []) => {
  const actions = !without.includes('actions') ? mapActions(commentsStore.moduleName, Object.keys(commentsStore.actionTypes)) : {}
  const getters = !without.includes('getters') ? mapGetters(commentsStore.moduleName, Object.keys(commentsStore.getterTypes)) : {}
  const mutations = !without.includes('mutations') ? mapMutations(commentsStore.moduleName, Object.keys(commentsStore.mutationTypes)) : {}

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  }
}
